import React from 'react';
import { motion } from 'motion/react';
import { CheckCircle2, AlertCircle, X } from 'lucide-react';
import { cn } from '../../lib/utils';

interface ToastProps {
  message: string;
  type: 'success' | 'info';
  onClose: () => void;
}

export const Toast = ({ message, type, onClose }: ToastProps) => (
  <motion.div
    initial={{ opacity: 0, y: 50, scale: 0.9 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, scale: 0.9 }}
    className={cn(
      "fixed bottom-8 right-8 z-[100] px-6 py-4 rounded-[2rem] shadow-2xl flex items-center gap-4 border backdrop-blur-xl",
      type === 'success' ? "bg-emerald-500 border-emerald-400 text-white" : "bg-slate-900 border-slate-800 text-white"
    )}
  >
    {type === 'success' ? <CheckCircle2 className="w-5 h-5" /> : <AlertCircle className="w-5 h-5 text-emerald-500" />}
    <p className="text-sm font-bold tracking-tight">{message}</p>
    <button onClick={onClose} className="ml-2 hover:bg-white/10 p-1 rounded-lg transition-colors">
      <X className="w-4 h-4" />
    </button>
  </motion.div>
);
